import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-menu-bi-config',
  templateUrl: './dialog-menu-bi-config.component.html',
  styleUrls: ['./dialog-menu-bi-config.component.scss'],
})
export class DialogMenuBiConfigComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
